/**
 * @kairos/types — barrel re-export for all Kairos domain schemas.
 * Extracted from src/schemas/ as part of TYPES-1-COMPLETE.
 */

export * from './_primitives.js';
export * from './shipment.js';
export * from './load.js';
export * from './tenant.js';
export * from './aegis.js';
export * from './workspace.js';
export * from './workspace-template.js';
export * from './agent.js';
export * from './event.js';
export * from './cost.js';
export * from './customer.js';
export * from './carrier.js';
export * from './invoice.js';
export * from './item.js';
export * from './reply-draft.js';
export * from './cognitive.js';
export * from './ledger.js';
export * from './user-preferences.js';
export * from './density.js';
export * from './iotEvents.js';
export * from './agentEval.js';
export * from './dataFlywheel.js';
export * from './idempotency.js';
export * from './kscan.js';
export * from './korch.js';
export * from './wmsRet.js';
export * from './intlGeo.js';
export * from './intlRates.js';
export * from './regulatoryArtifact.js';
export * from './iotCompliance.js';
export * from './kfed.js';
export * from './ktradecraft.js';
export * from './adversarialTwin.js';
export * from './kevolve.js';
export * from './iotPredictiveRisk.js';
export * from './iotAmbient.js';
export * from './coachWorkflow.js';
export * from './supply.js';
export * from './dockAppointments.js';
export * from './bookingFlow.js';
export * from './approvalRules.js';
export * from './dockCapacity.js';
export * from './bundle.js';
export * from './predictiveAlert.js';
export * from './transitComms.js';
export * from './quote.js';
export * from './claim.js';

import { LoadSchema }                                   from './load.js';
import { ShipmentSchema }                               from './shipment.js';
import { TenantSchema, AuditLogSchema,
         ValidationTelemetrySchema }                    from './tenant.js';
import { HaikuExtractionSchema, ReplyDraftSchema,
         SonnetDraftSchema, MetacognitionTraceSchema,
         MetacognitionScoresSchema,
         ConfidenceGateDecisionSchema }                 from './aegis.js';
import { CustomerSchema }                               from './customer.js';
import { CarrierSchema }                                from './carrier.js';
import { InvoiceSchema }                                from './invoice.js';
import { ItemSchema }                                   from './item.js';
import { ReplyDraftDocSchema }                          from './reply-draft.js';
import { CognitiveLoadScoreSchema }                     from './cognitive.js';
import { ProgressLedgerEntrySchema }                    from './ledger.js';
import { UserPreferencesSchema,
         TenantThemeSettingsSchema }                    from './user-preferences.js';
import { ItemIdentityRegistryDocSchema }                from './iotAmbient.js';
import { CoachWorkflowSchema, CoachConceptSchema,
         CoachSessionSchema, CoachFeedbackSchema,
         CoachProvenanceSchema }                        from './coachWorkflow.js';
import { SUPPLY_SCHEMA_REGISTRY }                        from './supply.js';
import { DockAppointmentSchema }                        from './dockAppointments.js';
import { BookingFlowSchema }                             from './bookingFlow.js';
import { DockCapacitySchema }                           from './dockCapacity.js';
import { BundleSchema }                                 from './bundle.js';
import { LoadPredictionStateSchema,
         CarrierBehaviorProfileSchema }                 from './predictiveAlert.js';
import { CommsThreadSchema,
         LoadGeofenceStateSchema,
         LoadCommsCadenceSchema }                       from './transitComms.js';

export const SCHEMA_REGISTRY = Object.freeze({
  loads:                       LoadSchema,
  shipments:                   ShipmentSchema,
  customers:                   CustomerSchema,
  carriers:                    CarrierSchema,
  invoices:                    InvoiceSchema,
  items:                       ItemSchema,
  reply_drafts:                ReplyDraftDocSchema,
  aegis_haiku:                 HaikuExtractionSchema,
  aegis_reply_draft:           ReplyDraftSchema,
  aegis_sonnet_draft:          SonnetDraftSchema,
  audit_log:                   AuditLogSchema,
  validation_telemetry:        ValidationTelemetrySchema,
  tenants:                     TenantSchema,
  aegis_metacognition_trace:   MetacognitionTraceSchema,
  aegis_metacognition_scores:  MetacognitionScoresSchema,
  confidence_gate_decisions:   ConfidenceGateDecisionSchema,
  cognitive_load_scores:       CognitiveLoadScoreSchema,
  progress_ledger_entries:     ProgressLedgerEntrySchema,
  user_preferences:            UserPreferencesSchema,
  tenant_settings:             TenantThemeSettingsSchema,
  item_identity_registry:      ItemIdentityRegistryDocSchema,
  coach_workflows:             CoachWorkflowSchema,
  coach_concepts:              CoachConceptSchema,
  coach_sessions:              CoachSessionSchema,
  coach_feedback:              CoachFeedbackSchema,
  coach_provenance:            CoachProvenanceSchema,
  ...SUPPLY_SCHEMA_REGISTRY,
  dock_appointments:           DockAppointmentSchema,
  booking_flow:                BookingFlowSchema,
  dock_capacity:               DockCapacitySchema,
  bundles:                     BundleSchema,
  // ── PREDICTIVE-ALERT-ENGINE-1 ─────────────────────────────────────────────
  load_prediction_state:       LoadPredictionStateSchema,
  carrier_behavior_profile:    CarrierBehaviorProfileSchema,
  // ── TRANSIT-COMMS-INTELLIGENCE-1 ──────────────────────────────────────────
  comms_threads:               CommsThreadSchema,
  load_geofence_state:         LoadGeofenceStateSchema,
  load_comms_cadence:          LoadCommsCadenceSchema,
});
